import type { ModalProps } from '@any-ui-react/core';

export const modalProps: Partial<ModalProps> = {
  withCloseButton: false,
  classNames: {
    header: 'border-b border-b-gray px-6 pt-4 pb-4 mb-4',
    body: 'px-6',
  },
};
